@if (isFormattedText()) {
  <div class="flex flex-wrap grow pl-0 overflow-hidden gap-0 items-center w-full">
    @for (line of getFormattedTextLines(); track $index) {
      <div class="leading-5 vertical-align-middle w-full">
        @if (line.isHtml) {
          <s-ui-view-code [value]="line.entry" />
        } @else {
          @if (line.key) {
            <div class="grid-nogutter leading-4 flex grow flex-wrap gap-0">
              <div class="col justify-start flex">
                <b>{{ line.key }}:</b>
              </div>
              <div class="col justify-end flex grow" [class]="line.valueClass?.join(' ')">
                <!--extra div needed when comment wraps-->
                <div>
                  @if (line.iconLeft) {
                    <i [class]="line.iconLeft" style="font-size: 0.95rem; vertical-align: middle"></i>
                  }
                  {{ line.value }}
                </div>
              </div>
            </div>
          } @else {
            @if (line.iconArray && line.iconArray.length > 0) {
              @for (icon of line.iconArray; track $index) {
                <i [class]="icon"></i>
              }
            } @else {
              @if (line.link?.path) {
                <span [class]="line.valueClass?.join(' ')">
                  @if (line.link?.protocol === 'https') {
                    <a
                      [routerLink]="line.link?.path"
                      [queryParams]="line.link?.queryParams"
                      target="{{ line.link?.target }}"
                    >
                      @if (line.iconLeft) {
                        <i [class]="line.iconLeft" style="font-size: 0.95rem; vertical-align: middle"></i>
                      }
                      {{ line.entry }}</a
                    >
                  } @else {
                    <a [href]="line.link?.getUrl()">
                      @if (line.iconLeft) {
                        <i [class]="line.iconLeft" style="font-size: 0.95rem; vertical-align: middle"></i>
                      }
                      {{ line.entry }}
                    </a>
                  }
                </span>
              } @else {
                <span [class]="line.valueClass?.join(' ')">
                  @if (line.iconLeft) {
                    <i [class]="line.iconLeft" style="font-size: 0.95rem; vertical-align: middle"></i>
                  }
                  {{ line.entry }}</span
                >
              }
            }
          }
        }
      </div>
    }
    @if (showEllipsis) {
      <div class="leading-4">&hellip;</div>
    }
  </div>
} @else {
  <div class="flex flex-auto content-center items-center justify-center font-bold">{{ value }}</div>
}
